<template>
    <div>
        <Overlay v-if="this.loading"></Overlay>
        <Loading v-if="this.loading"></Loading>
        <div class="card-header">
            <div class="row">
                <div class="col-sm-6 text-left mb-3">
                    <h2 class="card-title">Assign permissions</h2>
                </div>
            </div>
            <div class="categories" id="categories-list">
                <div class="card-category"
                     v-for="perm in this.perms" :key="perm.id"
                >
                    <div class="category-title">{{ perm.name }} <span class="badge-dark badge">{{ perm.nick }}</span></div>
                </div>
            </div>
        </div>
        <form @submit="addPerm" action="#">
            <div class="card-body mt-3">
                <transition
                        enter-active-class="animated fadeIn faster"
                        leave-active-class="animated fadeOut faster"
                >
                    <div class="alert alert-success" v-if="hasMessage">{{ message }}</div>
                </transition>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>User nickname</label>
                            <autocomplete :search="searchUser" placeholder="User nickname..." ref="userInput"></autocomplete>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Perm name</label>
                            <autocomplete :search="searchPerm" placeholder="Perm name..." ref="permInput"></autocomplete>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="submit" class="btn btn-fill btn-success">Add</button>
            </div>
        </form>
    </div>
</template>

<script>
    import axios from 'axios';
    import ApiService from "../../common/api.service";
    import Overlay from "../Overlay";
    import Loading from "../Loading";

    export default {
        name: "AdminAssignPerms",
        components: {
            Overlay,
            Loading
        },
        mounted(){
            this.retrievePerms();
        },
        data(){
            return {
                userName: '',
                perm: '',
                loading: false,
                hasMessage: false,
                message: '',
                perms: null
            }
        },
        methods: {
            getPerms(){
                return [...new Set(this.perms.map(x => x.name))];
            },
            getUsers(){
                return [...new Set(this.perms.map(x => x.nick))];
            },
            searchUser(input) {
                if (input.length < 1) { return [] }
                return this.getUsers().filter(x => {
                    return x.toLowerCase().indexOf(input.toLowerCase()) !== -1
                })
            },
            searchPerm(input) {
                if (input.length < 1) { return [] }
                return this.getPerms().filter(x => {
                    return x.toLowerCase().indexOf(input.toLowerCase()) !== -1
                })
            },
            addPerm(e){
                this.loading = true;
                let data = {
                    userName: this.$refs.userInput.value,
                    perm: this.$refs.permInput.value
                };
                axios.post(ApiService.getAction('admin', 'assignPerm'), data).then( (response) => {
                    this.message = response.data.status ? 'Role assigned' : 'An error occurred';
                    this.animated = true;
                    this.hasMessage = true;
                    this.retrievePerms();
                }).finally(() => this.loading = false);

                e.preventDefault();
            },
            retrievePerms(){
                this.loading = true;
                axios
                    .get(ApiService.getAction('admin', 'getPerms'))
                    .then(response => {
                        console.log(response);
                        this.perms = response.data.perms;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => this.loading = false)
            }
        }
    }
</script>

<style scoped>

</style>
